export function getThumbnail(url: any, width: any, applyWebp?: boolean): any {
    let file = url ? url : '61bd73d4-8331-41dd-a2ac-6fc8e46b6fe6'
    const _URL = useDirectusUrl()

    return !applyWebp
        ? new URL(`${_URL}/assets/${file}?width=${width}&fit=contain`).href
        : new URL(`${_URL}/assets/${file}.webp?width=${width}&fit=contain&format=webp`).href
}
